import { Icon } from '@chakra-ui/react';

export const HashSmallIcon = () => {
	return (
		<Icon
			w="19"
			h="19"
			viewBox="0 0 19 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.41755 15.4652L2.81199 14.7671L7.53021 3.34622C7.67264 3.00146 7.99512 2.76463 8.3667 2.7319L10.3822 2.55438C10.5314 2.54124 10.6416 2.69069 10.5849 2.82931L5.41755 15.4652Z"
				fill="white"
			/>
			<path
				d="M11.5652 16.1972C11.4361 16.5109 11.1568 16.7378 10.8233 16.7998L8.62783 17.2082C8.47223 17.2371 8.34625 17.0824 8.40611 16.9359L13.7008 3.97678L16.306 4.67484L11.5652 16.1972Z"
				fill="white"
			/>
			<path
				d="M10.2315 14.0138L10.9297 11.4082L14.8531 12.4595L13.7599 14.9592L10.2315 14.0138Z"
				fill="white"
			/>
			<path
				d="M4.05488 6.9765L5.11309 4.46784L8.085 5.26416L7.38695 7.86933L4.05488 6.9765Z"
				fill="white"
			/>
			<path
				d="M8.05297 8.10595L9.1197 5.59958L14.8806 7.0848L13.7233 9.56689L8.05297 8.10595Z"
				fill="white"
			/>
			<path
				d="M14.7696 10.4923L16.0827 7.40701L16.7654 7.58993L16.6322 10.9914L14.7696 10.4923Z"
				fill="#FF3F3F"
			/>
			<path
				d="M5.74813 12.8126L7.033 10.3642L11.1048 11.4553L10.0557 13.9668L5.74813 12.8126Z"
				fill="white"
			/>
			<path
				d="M2.54403 11.9535L2.72754 8.54541L4.41997 8.9989L3.12128 12.1082L2.54403 11.9535Z"
				fill="#FF3F3F"
			/>
			<path
				d="M7.04058 7.7926L2.81504 14.7649L5.81737 7.45841L7.04058 7.7926Z"
				fill="url(#paint0_linear_411_866)"
			/>
			<path
				d="M12.0914 11.708L16.2655 4.70372L13.284 12.0379L12.0914 11.708Z"
				fill="url(#paint1_linear_411_866)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_411_866"
					x1="6.05395"
					y1="8.04135"
					x2="4.30065"
					y2="11.6084"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#D8D8D8" />
					<stop
						offset="1"
						stopColor="white"
						stopOpacity="0"
					/>
				</linearGradient>
				<linearGradient
					id="paint1_linear_411_866"
					x1="13.1634"
					y1="11.9262"
					x2="15.1478"
					y2="6.59975"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#DFDFDF" />
					<stop
						offset="1"
						stopColor="white"
						stopOpacity="0"
					/>
				</linearGradient>
			</defs>
		</Icon>
	);
};
